import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  FormHelperText,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core'
import { addSMS, setMediaUrl } from '../../../actions/tasks'
import styles from '../styles'
import './sms.css'
import TextareaAutosize from 'react-textarea-autosize'
import { toggleDefaultValuesModal } from 'actions/template'
import { CodeBraces } from 'mdi-material-ui'
import { mergeFields, userMergeFields } from 'components/insertTools'
import { read } from 'actions/data'
import { receiveTemplate } from 'actions/template'
import S3ManagerMenu from 'components/Inbox/S3ManagerMenu'
import { Close } from '@material-ui/icons'
import textObjFn from 'utils/textObjFn'
import {
  Description,
  PictureAsPdf,
  Audiotrack,
  VideoLabel,
} from '@material-ui/icons'

const Handlebars = require('handlebars')

const PreviewAttachment = ({ mediaUrl, onClose }) => {
  const getFileType = url => {
    if (url.startsWith('data:')) {
      const mime = url.split(';')[0].split(':')[1]
      return mime
    }
    const extension = url.split('.').pop().toLowerCase()
    const extensionToMime = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      mp3: 'audio/mpeg',
      mp4: 'video/mp4',
      mov: 'video/quicktime',
    }
    return extensionToMime[extension] || 'unknown'
  }

  const fileType = getFileType(mediaUrl)
  const isImage = fileType.startsWith('image/')
  const isAudio = fileType.startsWith('audio/')
  const isVideo = fileType.startsWith('video/')
  const isPDF = fileType === 'application/pdf'

  const getIcon = () => {
    if (isPDF)
      return <PictureAsPdf style={{ fontSize: 48, color: '#014c94' }} />
    if (isAudio)
      return <Audiotrack style={{ fontSize: 48, color: '#014c94' }} />
    if (isVideo)
      return <VideoLabel style={{ fontSize: 48, color: '#014c94' }} />
    if (!isImage)
      return <Description style={{ fontSize: 48, color: '#014c94' }} />
    return null
  }

  return (
    <div style={{ marginTop: 8 }}>
      <div
        style={{
          position: 'relative',
          display: 'inline-block',
          padding: 8,
          border: '1px solid #e0e0e0',
          borderRadius: 4,
          backgroundColor: '#f5f5f5',
        }}
      >
        <div
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 3,
            top: 3,
            borderRadius: '50%',
            backgroundColor: '#014c94',
            cursor: 'pointer',
            height: 24,
            width: 24,
            zIndex: 1,
          }}
        >
          <Close style={{ color: '#fff' }} />
        </div>
        {isImage ? (
          <img
            style={{
              height: 100,
              maxWidth: '100%',
              display: 'block',
            }}
            alt="Attachment"
            src={mediaUrl}
          />
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '8px 16px',
            }}
          >
            {getIcon()}
            <span
              style={{
                marginTop: 4,
                fontSize: 12,
                color: '#666',
                maxWidth: 150,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {mediaUrl.split('/').pop()}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

class SMS extends Component {
  constructor() {
    super()
    this.ref = createRef()

    this.state = {
      focused: false,
      localValue: '',
    }
  }

  componentDidMount() {
    console.log('SMScomponentDidMount')
    console.log('this.props.taskForm', this.props.taskForm)
    console.log('this.props.templateID', this.props.templateID)

    if (
      this.props.taskForm &&
      this.props.templateID &&
      this.props.templateID !== 'new'
    ) {
      this.props
        .read(this.props.templateID, 'sms/template')
        .then(payload => {
          console.log('receiveTemplate payload', payload)
          this.props.receiveTemplate({ ...payload, type: 'sms' })
        })
        .then(() => {
          console.log('receiveTemplate then')
          console.log('this.props.messages', this.props.messages)
          this.setState({ localValue: this.props.messages || '' })
        })
    } else {
      console.log('this.props.messages', this.props.messages)
      this.setState({ localValue: this.props.messages || '' })
    }
  }

  componentDidUpdate(prevProps) {
    // Update local value when props change (but not during focus)
    if (!this.state.focused && prevProps.messages !== this.props.messages) {
      this.setState({ localValue: this.props.messages || '' })
    }
  }

  // Add method to sync state to redux
  syncToRedux = () => {
    console.log('syncToRedux')
    if (this.state.localValue !== this.props.messages) {
      this.props.addSMS(this.state.localValue)
    }
  }

  render() {
    const textObj = textObjFn(this.props)

    let compiledText = ''
    let text = ''

    try {
      compiledText = Handlebars.compile(this.props.messages || '')
      text = compiledText(textObj)
    } catch (error) {
      console.log(error)
    }

    return (
      <div className={this.props.classes.phoneContainer}>
        <div
          style={{
            maxWidth: 500,
            margin: 'auto',
          }}
        >
          <div
            style={
              this.props.error
                ? {
                    border: '1px solid red',
                    borderRadius: '8px',
                    position: 'absolute',
                  }
                : null
            }
          >
            <div className={this.props.classes.phone}>
              <div
                className={
                  this.props.mediaUrl
                    ? this.props.classes.chatWithAttachment
                    : this.props.classes.chat
                }
              >
                <TextareaAutosize
                  style={{
                    width: '100%',
                    backgroundColor: '#32ce5b',
                    color: '#fff',
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                    borderBottomRightRadius: 12,
                    padding: '8px 12px',
                    resize: 'none',
                    border: 'none',
                  }}
                  ref={this.ref}
                  placeholder="Type your text message here" // rows={15}
                  onChange={e => this.setState({ localValue: e.target.value })}
                  value={this.state.focused ? this.state.localValue : text}
                  onFocus={() => {
                    console.log('<SMS /> onFocus')
                    this.setState({ focused: true })
                  }}
                  onBlur={() => {
                    console.log('<SMS /> onBlur')
                    this.setState({ focused: false })
                    this.syncToRedux() // Sync to redux on blur
                  }}
                />
                <div className={this.props.classes.defaultValuesButton}>
                  <IconButton
                    onClick={() => this.props.toggleDefaultValuesModal(true)}
                    style={{
                      color: '#014c94',
                    }}
                  >
                    <CodeBraces />
                  </IconButton>
                </div>
                <div style={{ position: 'absolute', bottom: 5, right: 191 }}>
                  {/* <IconButton>
                    <AttachFile />
                  </IconButton> */}
                  <S3ManagerMenu
                    clickFile={media_url => this.props.setMediaUrl(media_url)}
                    style={{}}
                  />
                </div>
                <div
                  style={{
                    position: 'absolute',
                    bottom: 13,
                    right: 55,
                  }}
                >
                  <FormControl className={this.props.classes.formControl}>
                    <Select
                      value=""
                      onChange={e =>
                        this.props.addSMS(
                          this.props.messages + (e?.target?.value || ''),
                        )
                      }
                      displayEmpty
                      name="age"
                    >
                      <MenuItem value="">
                        <em>Merge fields...</em>
                      </MenuItem>
                      {[
                        ...mergeFields,
                        ...this.props.customAttributes,
                        ...userMergeFields,
                      ].map((field, idx) => (
                        <MenuItem
                          key={`mergeFieldMenu${idx}`}
                          value={field?.value}
                        >
                          {field?.text}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                {this.props.mediaUrl && (
                  <div style={{ position: 'absolute', bottom: 48 }}>
                    <PreviewAttachment
                      mediaUrl={this.props.mediaUrl}
                      onClose={() => this.props.setMediaUrl('')}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.props.error ? (
            <FormHelperText error>{this.props.error}</FormHelperText>
          ) : null}
        </div>
      </div>
    )
  }
}

export default connect(
  state => {
    const mergeFieldsPreviewSelectValue =
      state.tasks.addOrEdit.mergeFieldsPreviewSelect?.value
    const contact =
      mergeFieldsPreviewSelectValue === 'sample'
        ? {
            id: 'sample',
            first_name: 'Jane',
            middle_name: 'Emily',
            last_name: 'Doe',
            email: [
              {
                id: 'sample-email',
                address: 'jane.doe@example.com',
                opt_in: true,
                email_type: 'W',
              },
            ],
            phones: [
              {
                id: 'sample-phone',
                number: '+19999999999',
                opt_in: true,
                phone_type: 'M',
              },
            ],
            location: 'Huntingdon Valley, PA',
            notes: 'Such a nice person!',
            vastuser: Object.keys(state.data?.['account/user'] || {})?.[0],
          }
        : state.contacts.contactsWithEmailsByID?.[mergeFieldsPreviewSelectValue]

    return {
      messages: state.tasks.addOrEdit.sms.value,
      error: state.tasks.addOrEdit.sms.error
        ? state.tasks.addOrEdit.sms.error
        : null,
      customAttributes: state.contacts.customAttributes
        .filter(el => el.name)
        .map((el, idx) => ({
          text: `Contact's ${el.name}`,
          value: `{{ Contact.${el.name} }}`,
          id: idx + 12,
        })),
      templateID: state.email.templateID,
      mediaUrl: state.tasks.addOrEdit.mediaUrl,
      mergeFieldsPreviewSelectValue,
      contact,
      vastuser: state.data?.['account/user']?.[contact?.vastuser],
      preferences: state.data?.['account/preference']?.preferences,
      account: state.data?.account,
      assignedNumber: Object.values(state.data?.phonenumbers || {})?.find(
        numberObj => numberObj?.vast_user_name === contact?.vastuser,
      )?.phone_number,
      ...state.email.defaultValues,
    }
  },
  dispatch =>
    bindActionCreators(
      { addSMS, toggleDefaultValuesModal, read, receiveTemplate, setMediaUrl },
      dispatch,
    ),
)(withStyles(styles)(SMS))
